import type { RecordResource } from "../resources";

export default function RecordStatus<T>({ resource, following = false }: { resource: RecordResource<T>; following?: boolean }) {
  const pending = resource.data === null && resource.error === null;
  return <div className="space-y-2 text-sm min-w-0 break-words">
    <div className="flex flex-wrap items-center gap-3">
      <button type="button" onClick={resource.refresh} disabled={pending} className="px-3 py-2 bg-mesh-panel rounded disabled:opacity-40">
        {pending ? "Reading…" : resource.error ? "Retry" : "Refresh"}
      </button>
      <span className="text-mesh-mute" role="status">
        {pending ? "loading…" : resource.receivedAt != null ? <>{resource.error && "Cached observation · "}Observed <time dateTime={new Date(resource.receivedAt).toISOString()}>{new Date(resource.receivedAt).toLocaleString()}</time></> : "No successful observation"}
      </span>
    </div>
    {following && <p className="text-mesh-mute">Watching for a final or invalid result while this tab is visible.</p>}
    {resource.error && <p role="alert" className="bg-mesh-err/20 text-mesh-err p-3 rounded break-words">{resource.error}</p>}
  </div>;
}
